<script setup></script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="min-w-[16px]" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 12.5L1.10995 3.59951C1.05108 3.01082 1.51337 2.5 2.10499 2.5H5.58579C5.851 2.5 6.10536 2.60536 6.29289 2.79289L7.70711 4.20711C7.89464 4.39464 8.149 4.5 8.41421 4.5H11.095C11.6088 4.5 12.0389 4.88929 12.09 5.4005L12.1886 6.38594"
    />
    <path
      d="M4.22756 7.10608C4.38513 6.7384 4.74667 6.5 5.1467 6.5H14.4834C15.2013 6.5 15.6853 7.23405 15.4025 7.89392L13.2597 12.8939C13.1021 13.2616 12.7406 13.5 12.3405 13.5H3.00384C2.28593 13.5 1.8019 12.7659 2.0847 12.1061L4.22756 7.10608Z"
    />
  </svg>
</template>

<style scoped lang="scss"></style>
